import { render } from "./ITgads.vue?vue&type=template&id=b1ba1f66"
import script from "./ITgads.vue?vue&type=script&lang=js"
export * from "./ITgads.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__